import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { writeSessionToken } from '../lib/auth';

export function Landed() {
  const nav = useNavigate();
  useEffect(() => {
    const fragment = window.location.hash;
    const m = /session=([^&]+)/.exec(fragment);
    if (m) {
      writeSessionToken(decodeURIComponent(m[1]));
      window.history.replaceState({}, '', '/tenants');
      nav('/tenants', { replace: true });
    } else {
      nav('/', { replace: true });
    }
  }, [nav]);
  return (
    <div className="min-h-screen flex items-center justify-center text-slate-500">
      Signing you in…
    </div>
  );
}
